<template>
    <div id="form-data-table">
        <div class="form-data-table">
            <h3>Veri Tablosu</h3>
        </div>
    </div>
</template>
<script>
export default {
    name: "form-data-table",
}
</script>
<style scoped lang="scss">
#form-data-table{

}
</style>
